import React,{useContext} from 'react';
import { Fade } from 'react-awesome-reveal';

import { ThemeContext } from '../../../contexts/ThemeContext';

import './SingleService.css'


function SingleService({id, title, icon}) {

    const { theme } = useContext(ThemeContext);
    return (
        <Fade direction="up">
            <div key={id} className="single-service" /*style={{backgroundColor:theme.primary400}}*/>
                <div className="service-content"  style={{color:theme.secondary}}>
                    <i className="service-icon">{icon}</i>
                    <p style={{color:theme.secondary}}>{title}</p>  
                </div>         
            </div>
        </Fade>
    )
}

export default SingleService
